module.exports = __webpack_public_path__ + "static/media/entranceP.6c0160f3.jpg";